module.exports = "/packs/images/svg/facilities/day_pass~8594d014cb3ca3cadbbd0266ed0f71c6.svg";